<template>
  <div :class="`page-banner-area ${bannerHeight}`" :style="{ backgroundImage: `url(${cartbanner})` }">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="page-banner-content text-center">
            <h4 class="breadcrumb-title">{{ title }}</h4>
            <div class="breadcrumb-two">
              <nav>
                <nav class="breadcrumb-trail breadcrumbs">
                  <ul class="breadcrumb-menu">
                    <li class="breadcrumb-trail">
                      <router-link to="/"><span>Home</span></router-link>
                    </li>
                    <li class="trail-item">
                      <span>{{ subtitle }}</span>
                    </li>
                  </ul>
                </nav>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cartbanner from '@/assets/images/banner/page-banner-4.jpg'
export default {
  name: "BreadcrumbOne",
  props: {
    bannerHeight: {
      type: String,
      default: "page-banner-height-2",
    },
    banner: {
      type: String,
      default: "/images/banner/page-banner-4.jpg",
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
  data() {
        return {
          cartbanner,
        }
    },
};
</script>
